import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import ScreenHeader from './ScreenHeader';
import ScreenTable from './ScreenTable';
import { useState } from 'react';
import NewScreenModal from 'modules/dashboard/screens/Create';

const ScreenTabs = () => {
  const { id } = useParams<{ id: string }>();
  const [isNewScreenModalOpen, setIsNewScreenModalOpen] = useState(false);

  return (
    <Container>
      <ScreenHeader
        onNewScreen={() => setIsNewScreenModalOpen(true)}
        id={id || ''}
      />
      <ScreenTable id={id || ''} />
      <NewScreenModal
        open={isNewScreenModalOpen}
        onClose={() => setIsNewScreenModalOpen(false)}
      />
    </Container>
  );
};

export default ScreenTabs;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;
